import { useEffect, useState } from "react";
import { Loader2, Phone, Mail } from "lucide-react";
import api from "../../lib/api";
import { useLang } from "../../context/LanguageContext";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../../components/ui/select";
import { toast } from "sonner";

const STAGES = ["new", "contacted", "qualified", "won", "lost"];

export function Leads() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => { setLoading(true); const { data } = await api.get("/leads"); setItems(data.items); setLoading(false); };
  useEffect(() => { load(); }, []);

  const updateStage = async (id, stage) => { await api.patch(`/leads/${id}`, { stage }); toast.success("Updated"); load(); };

  const byStage = (s) => items.filter((l) => (l.stage || "new") === s);

  const stageColor = {
    new: "border-blue-500/40", contacted: "border-amber-500/40",
    qualified: "border-primary/40", won: "border-emerald-500/40", lost: "border-red-500/40",
  };

  if (loading) return <div className="grid place-items-center py-20"><Loader2 className="animate-spin text-primary" size={28} /></div>;

  return (
    <div>
      <h1 className="font-serif text-4xl font-light mb-2">{t("dash.pipeline")}</h1>
      <p className="text-muted-foreground font-light mb-8">{items.length} total leads</p>

      <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-5 gap-4" data-testid="lead-pipeline">
        {STAGES.map((stage) => (
          <div key={stage} className={`border-t-2 ${stageColor[stage]} bg-card border border-border`}>
            <div className="p-4 border-b border-border flex items-center justify-between">
              <span className="label-caps capitalize">{stage}</span>
              <span className="text-xs bg-secondary px-2 py-0.5">{byStage(stage).length}</span>
            </div>
            <div className="p-3 space-y-3 min-h-[100px]">
              {byStage(stage).map((l) => (
                <div key={l.id} className="bg-background border border-border p-3" data-testid={`lead-${l.id}`}>
                  <p className="font-medium text-sm">{l.name}</p>
                  {l.property_title && <p className="text-xs text-primary mt-0.5 truncate">{l.property_title}</p>}
                  <p className="text-xs text-muted-foreground mt-1 line-clamp-2">{l.message}</p>
                  <div className="flex items-center gap-2 mt-2 text-muted-foreground">
                    <a href={`tel:${l.phone}`} className="hover:text-primary"><Phone size={13} /></a>
                    <a href={`mailto:${l.email}`} className="hover:text-primary"><Mail size={13} /></a>
                    <span className="text-[0.65rem] ml-auto px-1.5 py-0.5 bg-secondary capitalize">{l.source}</span>
                  </div>
                  <Select value={l.stage || "new"} onValueChange={(v) => updateStage(l.id, v)}>
                    <SelectTrigger className="mt-2 rounded-none h-8 text-xs" data-testid={`lead-stage-${l.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>{STAGES.map((s) => <SelectItem key={s} value={s} className="capitalize">{s}</SelectItem>)}</SelectContent>
                  </Select>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
